import { getStoredExperiments } from "../experiment";
import store from "@utils/redux/store";

export default class ExperimentTracker {
  constructor() {
    this.setInitialOptimizelyProperties();
  }

  /**
   * Initializes Optimizely properties with data from the current session coming from the server context.
   */
  setInitialOptimizelyProperties() {
    const { serverContext } = store.getState();
    const mixpanelProperties = serverContext.mixpanel_properties || {};
    const optimizelyProperties = {};
    Object.keys(mixpanelProperties).forEach(property => {
      if (/^Optimizely/.test(property)) {
        optimizelyProperties[property] = mixpanelProperties[property];
      }
    });
    this.optimizelyProperties = optimizelyProperties;
  }

  /**
   * Returns
   *  - an object containing all optimizely properties in the current session.
   *  - a boolean whether there new client optimizely properties.
   */
  getOptimizelyProperties() {
    const clientOptimizelyProperties = ExperimentTracker.getClientOptimizelyProperties();
    const allOptimizelyProperties = {
      ...this.optimizelyProperties,
      ...clientOptimizelyProperties,
    };

    const hasNewProperties =
      Object.keys(allOptimizelyProperties).length >
      Object.keys(this.optimizelyProperties).length;

    this.optimizelyProperties = allOptimizelyProperties;

    return [this.optimizelyProperties, hasNewProperties];
  }

  /**
   * Returns an array of optimizely experiments with the following key value format:
   *    "Optimizely Experiment Name (Experiment Id): Variation Name (Variation Id)"
   */
  static getClientOptimizelyProperties() {
    const properties = {};
    try {
      if (!window.optimizely) {
        return {};
      }
      const experiments = window.optimizely
        .get("state")
        .getExperimentStates({ isActive: true });

      Object.values(experiments).forEach(value => {
        const experiment = `Optimizely ${value.experimentName} (${value.id})`;
        const variation = `${value.variation.name} (${value.variation.id})`;
        properties[experiment] = variation;
      });
    } catch (e) {
      console.log(e);
    }
    return properties;
  }

  static formatExperimentsStateString(experiments) {
    return experiments.reduce(
      (acc, experiment) =>
        Object.assign(acc, {
          [`Meristem ${experiment.experimentName}`]: experiment.variationName,
        }),
      {}
    );
  }

  /**
   * Get meristem experimentName: variationName to be sent with events.
   */
  static getMeristemExperimentState() {
    const experimentsState = getStoredExperiments();
    if (experimentsState) {
      return ExperimentTracker.formatExperimentsStateString(experimentsState);
    }
    return null;
  }

  /**
   * Format experiment state formated as visit data.
   */
  static formatMeristemExperimentStateVisitData(experimentsState) {
    if (experimentsState && experimentsState.length > 0) {
      return {
        meristem_experiment: ExperimentTracker.formatExperimentsStateString(
          experimentsState
        ),
      };
    }
    return null;
  }
}
